module.exports = __webpack_public_path__ + "img/medical-device.1559f90e.jpg";